import { IQTablePagination } from '@/quasar-types'
import { isAutenticated } from '@ultraware/vue-user-management'
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class/lib/bindings'

const tableSettings = namespace('tableSettings')

@Component({})
export default class TableStorageMixin extends Vue {
  @tableSettings.Mutation public updateTableSettings!: (_: object) => void
  @tableSettings.Getter public getTableSettings!: (_: string) => void

  public namespace?: string
  public pagination?: IQTablePagination
  public filter?: string
  public visibleColumns?: string[]

  public created(): void {
    // @ts-ignore
    const savedTableSettings: ITableSettings = this.getTableSettings(this.namespace)

    if (savedTableSettings) {
      this.pagination = savedTableSettings.pagination
      this.filter = savedTableSettings.filter
      this.visibleColumns = savedTableSettings.visibleColumns
    }
  }

  public beforeDestroy(): void {
    if (!isAutenticated()) return
    this.updateTableSettings({
      namespace: this.namespace,
      filter: this.filter,
      visibleColumns: this.visibleColumns,
      pagination: {
        sortBy: this.pagination!.sortBy,
        descending: this.pagination!.descending,
        rowsPerPage: this.pagination!.rowsPerPage,
        page: this.pagination!.page,
      },
    })
  }
}
